/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'edit': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M29.687 14.232l.51.511 3.06 3.06.511.51.51-.51 1.021-1.019.509-.512a.722.722 0 0 0 0-1.02l-3.059-3.059a.724.724 0 0 0-1.021-.001l-.511.51-1.019 1.021-.511.509zM15.615 28.305l12.84-12.84 4.08 4.081-12.84 12.84zM14.379 29.54l-2.364 6.152c-.101.262.03.393.292.292l6.152-2.363-4.08-4.081z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/edit.js